import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {TtdCategory} from '../../../target/target.service';

@Component({
  selector: 'app-ttd-category-content',
  template: `
    <table data-cy="element-ttd-category-list" mat-table [dataSource]="categories | categorySort"
           class="mat-elevation-z8"
           id="table-ttd-category-config">

      <ng-container matColumnDef="displayName">
        <th mat-header-cell *matHeaderCellDef>Display Name</th>
        <td mat-cell *matCellDef="let element"
            data-cy="element-ttd-category-list-cell-name"> {{ element.displayName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="parentId">
        <th mat-header-cell *matHeaderCellDef>Parent ID</th>
        <td mat-cell *matCellDef="let element"> {{ element.parentId }}</td>
      </ng-container>

      <ng-container matColumnDef="providerElementId">
        <th mat-header-cell *matHeaderCellDef>Category ID</th>
        <td mat-cell *matCellDef="let element"
            data-cy="element-ttd-category-list-cell-id"> {{ element.providerElementId }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnNames; sticky: true"></tr>
      <tr mat-row *matRowDef="let ttdCategories; columns: columnNames"></tr>
    </table>
  `,
  styleUrls: ['./ttd-category-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TtdCategoryContentComponent implements OnInit {
  columnNames = ['displayName', 'parentId', 'providerElementId'];

  @Input() categories: TtdCategory[] = [];

  constructor() {
  }

  ngOnInit(): void {
  }

}
